<template>
	<div :class="{
		'video': true,
		'video--forest': videoType === 'forest',
		'video--ocean': videoType === 'ocean',
		'video--active': activeVideo === videoType,
		'video--activeMobile': activeVideoMobile === videoType,
		'loading': true
		}">
		<p class="video__tooltip">Watch carefully:<br> find and click on your golden moment for your chance to<br> WIN A HOLIDAY IN JAPAN FOR TWO!</p>
		<video :src="videoUrl" :poster="posterUrl" preload muted playsinline/>
		<a
			href="#golden-moment"
			:class="{'video__golden-moment': true, 'video__golden-moment--active': activeGoldenMoment === videoType}"
			@click.prevent="$emit('showLightbox');$root.dispatchEvent('goldenMoment', {type: videoType});"
		></a>
	</div>
</template>

<script>
export default {
	props: {
		videoType: {
			type: String,
			required: true,
		},
		activeVideo: {
			type: String,
			required: false,
		},
		activeVideoMobile: {
			default: null,
			type: String,
			required: false,
		},
		activeGoldenMoment: {
			type: String,
			required: false,
		},
	},
	computed: {
		videoUrl () {
			return this.$store.getters.isMobile ? require(`../assets/${this.videoType}-mobile.mp4`) : require(`../assets/${this.videoType}.mp4`);
		},
		posterUrl () {
			return this.$store.getters.isMobile ? require(`../assets/${this.videoType}-poster-mobile.jpg`) : require(`../assets/${this.videoType}-poster.jpg`);
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	.video { opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; z-index: 2;
		&--active { opacity: 1; z-index: 3; }
		video { width: 100%; }

		&__golden-moment { visibility: hidden; position: absolute; top: 0; left: 0; width: 5vw; height: 5vw; transform: rotate(27deg); background-color: transparent; }
		&--forest &__golden-moment { transform: rotate(65deg); }
		&__golden-moment--active { visibility: visible; }

		&--activeMobile { position: fixed; opacity: 1; z-index: 20; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, .8);
			video { margin: auto; }
		}

		&__tooltip { opacity: 0; transition: opacity 1s ease; .top-left(5%, 0, 4); .size(100%, auto); color: white; font-size: 24px; text-align: center; font-weight: bold; text-shadow: 1px 1px 5px black;
			&.active { opacity: 1; }
		}
	}
	@media @mobile {
		.video {
			@keyframes loading {
				0% { transform: rotate(0deg); }
				100% { transform: rotate(360deg); }
			}
			&.loading {
				&:before { .top-left(~"calc(50% - 5vw)", ~"calc(50% - 5vw)", 4); content: ""; display: block; .size(10vw); margin-bottom: 1em; border-radius: 50%; border: 2px solid black; border-top-color: #e60017; animation: 1s loading infinite; }
				&:after { .top-left(55%, 0, 4); content: "Loading video..."; display: block; width: 100vw; text-align: center; color: black; }
			}

			&__golden-moment { width: 10vw; height: 10vw; z-index: 4; }
			&--activeMobile {
				video { position: relative; z-index: 3; }
			}

			&__tooltip { top: 12vh; font-size: 16px; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/MomentsSectionVideo.vue